import { get } from "./api.service";

const ExternalService = {
  getGeoLocationByIP() {
    return get("https://ipgeolocation.abstractapi.com/v1?api_key=2fc42f6fbb6b4707805c838daa4d9d06");
  },
};

export { ExternalService };
